import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PipesModule, SaI18nPipe, XsI18nPipe } from '@nx-fe/pipes';
import { XSi18nService } from '@nx-fe/services';
import { TooltipModule } from '@soti/tooltip';

@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatTooltipModule,
        PipesModule,
        TooltipModule
    ],
    providers: [
        XsI18nPipe,
        SaI18nPipe,
        XSi18nService,
    ],
    exports: [
    ]
})
export class XsightModule {}
